<template>
  <v-container fluid>
    <v-btn variant="text" href="mailto:a.selidaire@orange.fr">
      <v-icon size="large">mdi-email</v-icon>
      a.selidaire@orange.fr
    </v-btn>
    <v-slide-y-transition mode="out-in">
      <div class="d-flex flex-column align-center"></div>
    </v-slide-y-transition>
  </v-container>
</template>
